"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createHumps;
var _map2 = _interopRequireDefault(require("lodash/fp/map"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/fp/isPlainObject"));
var _isObjectLike2 = _interopRequireDefault(require("lodash/fp/isObjectLike"));
var _isArray2 = _interopRequireDefault(require("lodash/fp/isArray"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _transform2 = _interopRequireDefault(require("lodash/transform"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function createIteratee(converter, self) {
  return function (result, value, key) {
    return (0, _set2["default"])(result, converter(key), (0, _isObjectLike2["default"])(value) ? self(value) : value);
  };
}
function createHumps(keyConverter) {
  return function humps(node) {
    if ((0, _isArray2["default"])(node)) return (0, _map2["default"])(humps, node);
    if ((0, _isPlainObject2["default"])(node)) return (0, _transform2["default"])(node, createIteratee(keyConverter, humps));
    return node;
  };
}
module.exports = exports.default;